module.exports = __webpack_public_path__ + "img/one.7437e5ca.png";